import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "产品定价", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { style: {"margin-top":"2rem"} }, "计费构成", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { style: {"margin-top":"2rem"} }, "计费规则", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"1rem","margin-bottom":"10rem"} }, [
  /*#__PURE__*/_createTextVNode(" 说明："),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("         1. 以上资源包的有效期为购买之日起1年以内。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("         2. 每个资源包最大可支持200路并发，如您有更大规模的并发需求，请联系商务经理。 ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_el_table, {
      data: _ctx.tableData,
      border: "",
      style: {"width":"100%","margin-top":"2rem"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "服务",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "desc",
          label: "计费方式",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "more",
          label: "补充说明"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _hoisted_3,
    _createVNode(_component_el_table, {
      data: _ctx.quotationData,
      border: "",
      "header-cell-style": _ctx.headCellClass,
      "span-method": _ctx.objectSpanMethod,
      style: {"width":"100%","margin-top":"2rem"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "按次计费报价表",
          align: "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "type",
              label: "服务类型",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "size",
              label: "资源包规格",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "price",
              label: "资源包价格(元)",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "unitPrice",
              label: "单价"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style", "span-method"]),
    _hoisted_4
  ], 64))
}